module.exports = __webpack_public_path__ + "static/media/favicon.6d197c5a.png";